var map = {
	"./Authorization.svg": 310,
	"./Claim.svg": 311,
	"./ClaimSubmissionBatch.svg": 312,
	"./HelpCenter.svg": 313,
	"./Inquiry.svg": 314,
	"./Medication.svg": 315,
	"./OASIS Profile.svg": 316,
	"./Order.svg": 317,
	"./Page.svg": 318,
	"./Patient.svg": 319,
	"./Physician.svg": 320,
	"./Referral.svg": 321,
	"./Remittance.svg": 322,
	"./Report.svg": 323,
	"./Task.svg": 324,
	"./User.svg": 325,
	"./default.svg": 326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 349;